module.exports = __webpack_public_path__ + "static/media/clear.d94dcbed.png";